// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"356e1a69","605":"4f6ac4c3","809":"62452d41","981":"2862c6ad"}[chunkId] + ".chunk.js";
};